import { FC, SVGProps, MouseEvent, CSSProperties } from "react"
import classNames from "classnames"
import icons from "@/assets/icons"
import "./index.scss"

export enum IconColor {
   JET_BLACK = "--jet-black",
   WHITE = "--white",
   HONOLULU_BLUE_DARK = "--honolulu-blue-dark",
   HONOLULU_BLUE = "--honolulu-blue",
   HONOLULU_BLUE_LIGHT = "--honolulu-blue-light",
   COOL_GRAY = "--cool-gray",
   SILVER = "--silver",
   GUNMETAL = "--gunmetal",
   CERISE = "--cerise",
   CRIMSON = "--crimson",
   GRAY = "--gray",
   XANTHOUS = "--xanthous",
}

export type IconProps = SVGProps<SVGSVGElement> & {
   name: keyof typeof icons
   className?: string
   style?: CSSProperties
   size?: string
   width?: string
   height?: string
   color?: IconColor
   disabled?: boolean
   ["data-testid"]?: string
   onClick?: (e: MouseEvent) => void
}

const defaultOnClick = () => {}

export const Icon: FC<IconProps> = ({
   name,
   size = "24",
   width,
   height,
   color = IconColor.JET_BLACK,
   disabled = false,
   className,
   style,
   ["data-testid"]: dataTestId,
   onClick = defaultOnClick,
}) => {
   const IconComponent = icons[name]

   if (!IconComponent) {
      console.warn(`Icon "${name}" not found!`)
      return null
   }

   return (
      <IconComponent
         className={classNames("icon", `icon${color}`, className, {
            "icon--clickable": onClick !== defaultOnClick,
            "icon--disabled": disabled,
         })}
         name={name}
         color={color}
         width={width || size}
         height={height || size}
         {...(onClick && { onClick: onClick })}
         {...(style && { style: style })}
         {...(dataTestId && { "data-testid": dataTestId })}
      />
   )
}
